import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LoyaltyProgramBonusFollowup } from 'src/app/assabil-sales/models/dtos/loyalty-program-bonus-followup';

@Component({
  selector: 'loyalty-program-bonus-followup',
  templateUrl: './loyalty-program-bonus-followup.component.html',
  styleUrls: ['./loyalty-program-bonus-followup.component.scss']
})
export class LoyaltyProgramBonusFollowupComponent implements OnInit {

  @Input() geoArea    ;
  @Input() loyaltyProgramBonusFollowup : LoyaltyProgramBonusFollowup;

  @Output() onClick        = new EventEmitter<any>();

  
  constructor() { }

  ngOnInit() {
  }


  clickBonus()              { this.onClick.emit({loyaltyProgram : this.loyaltyProgramBonusFollowup.loyaltyProgramCode, geoArea : this.geoArea, kpi : "Bonus"} );} 
  clickConsumedBonus()      { this.onClick.emit({loyaltyProgram : this.loyaltyProgramBonusFollowup.loyaltyProgramCode, geoArea : this.geoArea, kpi : "ConsumedBonus"} );} 
  clickNotyetConsumedBonus()      { this.onClick.emit({loyaltyProgram : this.loyaltyProgramBonusFollowup.loyaltyProgramCode, geoArea : this.geoArea, kpi : "NotyetConsumedBonus"} );} 
  clickNearlyExpiredBonus() { this.onClick.emit({loyaltyProgram : this.loyaltyProgramBonusFollowup.loyaltyProgramCode, geoArea : this.geoArea, kpi : "NearlyExpiredBonus"} );}

}